import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {GetMeetingsSidebarCounts as GetMeetingsSidebarCountsQuery} from 'nutshell-graphql-types';

import GET_MEETINGS_SIDEBAR_COUNTS from '../queries/get-meetings-sidebar-counts.graphql';

export const useGetMeetingsSidebarCounts = (skip?: boolean) => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetMeetingsSidebarCountsQuery, Record<any, any>>(GET_MEETINGS_SIDEBAR_COUNTS, {
        fetchPolicy: 'cache-and-network',
        skip,
    });

    const {meetingsSidebarCounts} = makeDataDangerous(data);

    return {
        isLoading,
        meetingsSidebarCounts,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
